import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { ApiQueryParams, TradingOffer } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

type GetTradingOfferByIdProps = {
  tradingOfferId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getTradingOffer =
  ({ tradingOfferId, params = {}, signal }: GetTradingOfferByIdProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/tradingOffers/${tradingOfferId}`, {
        params,
        // signal,
      });

      const decodedData = (await decryptResponse(data)) as TradingOffer;

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
      throw error;
    }
  };
